import React, { createContext, useContext, useState } from 'react';
import { LoadScript } from '@react-google-maps/api';

const MAP_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "YOUR_GOOGLE_MAPS_API_KEY_HERE";
const LIBRARIES = ["places", "marker"];

const GoogleMapsContext = createContext(null);

export const GoogleMapsProvider = ({ children }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [loadError, setLoadError] = useState(null);

  if (!MAP_API_KEY) {
    console.error('Google Maps API anahtarı bulunamadı. Lütfen .env dosyanızda REACT_APP_GOOGLE_MAPS_API_KEY değişkenini ayarlayın.');
  }

  const handleLoad = () => {
    setIsLoaded(true);
  };

  const handleError = (error) => {
    console.error('Google Maps API yüklenirken hata oluştu:', error);
    setLoadError(error);
  };

  return (
    <GoogleMapsContext.Provider value={{ isLoaded, loadError }}>
      <LoadScript
        googleMapsApiKey={MAP_API_KEY}
        libraries={LIBRARIES}
        onLoad={handleLoad}
        onError={handleError}
      >
        {children}
      </LoadScript>
    </GoogleMapsContext.Provider>
  );
};

export const useGoogleMaps = () => {
  const context = useContext(GoogleMapsContext);
  if (!context) {
    throw new Error('useGoogleMaps hook must be used within a GoogleMapsProvider');
  }
  return context;
};

export default GoogleMapsContext;
